/**
 * Get initials from a name string.
 * Takes the first letter of each word (up to maxChars).
 *
 * @example
 * getInitials("John Doe") // "JD"
 * getInitials("Alice Bob Charlie", 2) // "AB"
 * getInitials(undefined) // "?"
 */
export function getInitials(name?: string | null, maxChars = 2): string {
  if (!name?.trim()) return '?';
  return name
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((word) => word[0]?.toUpperCase() || '')
    .slice(0, maxChars)
    .join('');
}
